import { AllSchedulesView } from "./components/AllSchedulesView";
import { schedulesSampleData } from "./models/schedulesSampleData";

const Schedules = () => {
  return <AllSchedulesView schedulesData={schedulesSampleData} />;
};

export default Schedules;
